const options = [
    {
        label: 'About',
        childOptions: [
            {
                chLabel: 'Aim',
                navigateTo: "/ourAim"
            },
            {
                chLabel: 'History',
                navigateTo: "/ourHistory"
            },
            {
                chLabel: 'Profile',
                navigateTo: "/profile"
            },
            {
                chLabel: 'Management',
                navigateTo: "/management"
            },
            {
                chLabel: 'Message'
            },
            {
                chLabel: 'Activities',
                navigateTo: "/activities"
            },
            {
                chLabel: 'Download Prospectus'
            },
            {
                chLabel: 'College Document'
            }
        ]
    },
    {
        label: 'Administration',
        childOptions: [
            {
                chLabel: 'Departments'
            },
            {
                chLabel: 'Governing Body'
            },
            {
                chLabel: 'Principal Message'
            },
            {
                chLabel: 'Secratary Message'
            },
            {
                chLabel: 'Class 3 employee'
            },
            {
                chLabel: 'Class 4 Employee'
            },
            {
                chLabel: 'Department Incharges'
            }
        ]
    },
    {
        label: 'Courses',
        childOptions: [
            {
                chLabel: 'Post Graduates'
            },
            {
                chLabel: 'Under Graduates'
            },
            {
                chLabel: 'Diploma Courses'
            },
            {
                chLabel: 'Certificate Courses'
            }
        ]
    },
    {
        label: 'Faculty',
        childOptions: [
            {
                chLabel: 'Faculty of Arts'
            },
            {
                chLabel: 'Faculty of Science'
            },
            {
                chLabel: 'Re-Appointed Faculty'
            },
            {
                chLabel: 'IGNOU Study Center'
            }
        ]
    },
    {
        label: 'E-Newsletter',
        childOptions: [
            {
                chLabel: 'E - Fauna'
            },
            {
                chLabel: 'E - Botany'
            },
            {
                chLabel: 'E - Chemistry'
            }
        ]
    },
    {
        label: 'Results'
    },
    {
        label: 'Legal Aid Clinic',
        navigateTo: '/legalaid'
    },
    {
        label: 'NAAC',
        childOptions: [
            {
                chLabel: 'IQAC'
            },
            {
                chLabel: 'AQAR'
            }
        ]
    },
    {
        label: 'ARIIA 2021'
    },
    {
        label: 'NIRF',
        childOptions: [
            {
                chLabel: '2018-2019'
            },
            {
                chLabel: '2019-2020'
            },
            {
                chLabel: '2021'
            },
            {
                chLabel: '2021-2022'
            }
        ]
    },
    {
        label: 'AISHE',
        childOptions: [
            {
                chLabel: '2020-2021'
            },
            {
                chLabel: '2021-2022'
            }
        ]
    },
];

export { options };